/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { models_CreateEventRequest } from '../models/models_CreateEventRequest';
import type { models_EventDeleteResponse } from '../models/models_EventDeleteResponse';
import type { models_EventResponse } from '../models/models_EventResponse';
import type { models_EventsListResponse } from '../models/models_EventsListResponse';
import type { models_UpdateEventRequest } from '../models/models_UpdateEventRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EventsService {
    /**
     * List events
     * Returns a list of all events the authenticated partner has access to
     * @param organizer Organizer slug
     * @param skip Number of results to skip
     * @param take Number of results to return (max 100)
     * @param search Search term
     * @param isPublic Filter by public events
     * @param live Filter by live events
     * @param ordering Ordering field
     * @returns models_EventsListResponse OK
     * @throws ApiError
     */
    public static getOrganizersEvents(
        organizer: string,
        skip?: number,
        take?: number,
        search?: string,
        isPublic?: boolean,
        live?: boolean,
        ordering?: string,
    ): CancelablePromise<models_EventsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/events',
            path: {
                'organizer': organizer,
            },
            query: {
                'skip': skip,
                'take': take,
                'search': search,
                'is_public': isPublic,
                'live': live,
                'ordering': ordering,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Create event
     * Creates a new event (requires appropriate permissions)
     * @param organizer Organizer slug
     * @param body Event data
     * @returns models_EventResponse Created
     * @throws ApiError
     */
    public static postOrganizersEvents(
        organizer: string,
        body: models_CreateEventRequest,
    ): CancelablePromise<models_EventResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/events',
            path: {
                'organizer': organizer,
            },
            body: body,
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieve event
     * Returns details of a specific event
     * @param organizer Organizer slug
     * @param event Event slug
     * @returns models_EventResponse OK
     * @throws ApiError
     */
    public static getOrganizersEvents1(
        organizer: string,
        event: string,
    ): CancelablePromise<models_EventResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/events/{event}',
            path: {
                'organizer': organizer,
                'event': event,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Update event
     * Updates an existing event
     * @param organizer Organizer slug
     * @param event Event slug
     * @param body Event data
     * @returns models_EventResponse OK
     * @throws ApiError
     */
    public static putOrganizersEvents(
        organizer: string,
        event: string,
        body: models_UpdateEventRequest,
    ): CancelablePromise<models_EventResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/events/{event}',
            path: {
                'organizer': organizer,
                'event': event,
            },
            body: body,
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Delete event
     * Deletes an event (requires appropriate permissions)
     * @param organizer Organizer slug
     * @param event Event slug
     * @returns models_EventDeleteResponse OK
     * @throws ApiError
     */
    public static deleteOrganizersEvents(
        organizer: string,
        event: string,
    ): CancelablePromise<models_EventDeleteResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/events/{event}',
            path: {
                'organizer': organizer,
                'event': event,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
